import { createSlice } from "@reduxjs/toolkit";
import { PartComponentType } from "../models/PartComponentType";

const PartComponentTypeInitialState: {
	partComponentType: PartComponentType[];
} = {
	partComponentType: [],
};

export const PartComponentTypeReducer = createSlice({
	name: "__",
	initialState: PartComponentTypeInitialState,
	reducers: {
		setPartComponentType(state, { payload }) {
			state.partComponentType = payload;
		},
	},
});
